//
import { getFetchDataFunction } from '../DataTableService'

//
const route = process.env.VUE_APP_API_ROUTE.concat('/wh_product')

//
export default getFetchDataFunction(route,[], [])
